import { SHOP_STATUS, BUSINESS_STATUS } from '@RootCommon/constants/shopInfo'
import { getEnv } from '@/common/utils'
import { ShopInfoVo, BrandInfoVo, PassportUserVo, AccountDetailInfoVO, MerchantMallHref } from '@/@types'
import { getRegionByCookie, getLanguage } from '@RootCommon/utils'

export const NO_BRAND_ID = '-9999'
export const NO_BRAND_ACC_ID = '-999999999'

const getRootPath = () => {
  if (process_env_CDN_REGION === 'CN') return '/cn/'
  const { pathname: topPathname } = window.top.location
  if (topPathname.startsWith('/order-manager')) return '/order-manager/'
  return '/'
}

export const ROOT_PATH = getRootPath()
// console.log(process_env_CDN_REGION, ROOT_PATH, 'process_env_CDN_REGION', process_env_CDN_REGION === 'CN', process_env_CDN_REGION === 'HK')

// 子账号角色
export const ACCOUNT_ROLE = {
  ASSISTANT: 2,
  FINANCE: 3,
  MARKETING_SPECIALIST: 4,
  MANAGER: 1,
  GROUP_MANAGER: 5,
  GROUP_FINANCE: 6,
  GROUP_ORDER: 7,
}

export const MENU_VIEWTYPE = {
  ALL: 'all',
  SINGLE: 'single',
}

export const ALL_SHOP: ShopInfoVo = {
  value: 0,
  label: '全部门店',
  name: '全部门店',
  shopId: 0,
  status: SHOP_STATUS.NONE,
  businessStatus: BUSINESS_STATUS.NONE,
}

export const ALL_BRAND: BrandInfoVo = {
  value: '0',
  label: '全部品牌',
  name: '全部品牌',
  brandName: '全部品牌',
  acctId: '0',
  brandId: '0',
  shopId: 0,
  status: SHOP_STATUS.NONE,
  businessStatus: BUSINESS_STATUS.NONE,
}

export const ON_BRAND_INFO: BrandInfoVo = {
  value: NO_BRAND_ID,
  label: '',
  name: '',
  brandName: '',
  brandId: NO_BRAND_ID,
  // status: SHOP_STATUS.NONE,
  // businessStatus: BUSINESS_STATUS.NONE,
}

export const DEFAULT_BRAND: BrandInfoVo = {
  value: '0',
  label: '',
  name: '',
  brandName: '',
  acctId: '0',
  brandId: '0',
  shopId: 0,
  status: SHOP_STATUS.NONE,
  businessStatus: BUSINESS_STATUS.NONE,
}

export const ERROR_SHOP: ShopInfoVo = {
  value: -1,
  label: '无可用门店',
  name: '无可用门店',
  shopName: '无可用门店',
  disabled: true,
  shopId: -1,
  status: SHOP_STATUS.NONE,
  businessStatus: BUSINESS_STATUS.NONE,
}

export const DEFAULT_PASSPORT_USERINFO: PassportUserVo = { username: '', email: '', uid: '' }

export const DEFAULT_MERCHANT_USERINFO: AccountDetailInfoVO = { acctType: 0, accountType: 0, acctId: '' }

export const AUTH_MENU_KEY = {
  HEALTHY: 'merchant_healthy',
  AD: 'advertisement',
  OPENAPI: 'openapi',
  OPENAPI_APP_ACTIVATION: 'openapi_app_activation',
  GROWTH: 'merchant_growth',
  NEWORDER: 'merchant_new_order_list',
  SUBACCOUNT: 'subAccountList',
  MERCHANT_MARKET: 'merchant_market',
}

export const MENU_AUTH_STATUS = {
  HAS_PERMISSION: 1,
  NO_PERMISSION: 2,
}

export const enum AD_GUIDE_COMP_FILTER {
  guide = 'guide',
  activity = 'activity'
}

export const enum AD_GUIDE_UPDATE_MODE {
  show = 0,
  click = 1,
}

export enum OperationTypeIds {
  menuAdLabel = 20105,
  multiShopAdLabel = 20109,
}
export enum AdInfoGuideType {
  no = 0,
  new = 1,
  dot = 2,
}

// export const MERCHANT_MALL_ORIGIN = {
//   production: 'https://merchant.mykeeta.com',
//   staging: 'https://merchant.mykeeta.st.sankuai.com',
//   test: `https://${process.env.SWIMLANE ? `${process.env.SWIMLANE}-sl-` : ''}merchant.mykeeta.test.sankuai.com`,
//   dev: 'https://merchant.mykeeta.dev.sankuai.com',
// }[getEnv()]


export const MERCHANT_MALL_MENU_PATH_PREFIX = '/diagonalley/pc'

export const MERCHANT_MALL_PATH_MAP = {
  // 全部商品
  list: {
    path: MERCHANT_MALL_MENU_PATH_PREFIX,
    hash: '/list?market_level=2',
    hashParams: {
    },
  },
  // 我的专供商品
  exclusive: {
    path: MERCHANT_MALL_MENU_PATH_PREFIX,
    hash: '/exclusive',
    hashParams: {
    },
  },
  // 我的订单
  orderList: {
    path: MERCHANT_MALL_MENU_PATH_PREFIX,
    hash: '/orderlist',
    hashParams: {
    },
  },
  // 优惠券
  couponList: {
    path: MERCHANT_MALL_MENU_PATH_PREFIX,
    hash: '/couponList',
    hashParams: {
    },
  },
}

export const MERCHANT_MALL_MENU_PATH: MerchantMallHref = (() => {
  const menuPath = {} as MerchantMallHref

  Object.entries(MERCHANT_MALL_PATH_MAP).forEach(([key, value]) => {
    menuPath[key] = `${value.path}#${value.hash}`
  })

  return menuPath
})()

// export const MERCHANT_MALL_ENABLED = getGrayConfig().merchant_market && getRegionByCookie() === 'HK' && getLanguage()?.includes('zh')
export const MERCHANT_MALL_ENABLED = (() => {
  let enable = getRegionByCookie() === 'HK' && getLanguage()?.includes('zh')
  enable = !!enable
  console.log('MERCHANT_MALL_ENABLED', enable)
  return enable
})()

export const SideMenuCategoryKeyValueMap = {
  'sales_performance': '销售表现',
  'product_management': '商品管理',
  'marketing_promotion': '营销推广',
  'general': '通用功能',
  'Settings': '设置',
}

export const LS_PRINT = 'print_settings'